// Angular
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
// Material
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
// Translate
import { TranslateModule } from "@ngx-translate/core";
// CRUD
import { InterceptService } from "../../../core/_base/crud/";
// Module components
import { AuthComponent } from "./auth.component";
import { LoginComponent } from "./login/login.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
// Auth
import { AuthGuard } from "../../../core/auth";
import { ChangePasswordComponent } from "./change-password/change-password.component";
// Core
import { CoreModule } from "../../../core/core.module";
import { DownloadPdfComponent } from "./download-pdf/download-pdf.component";
import { listTermsComponent } from "./terms-dialog/list-terms.component";
import { MatDialogModule } from "@angular/material/dialog";
import { RecaptchaDirective } from "./recaptcha.directive";
import { BrowserModule } from "@angular/platform-browser";
import { InputCodeComponent } from "./input-code/input-code.component";
import { MatIconModule } from "@angular/material/icon";

const routes: Routes = [
  {
    path: "",
    component: AuthComponent,
    children: [
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "login",
        component: LoginComponent,
        data: { returnUrl: window.location.pathname },
      },
      {
        path: "forgot-password",
        component: ForgotPasswordComponent,
      },
      {
        path: "remember/:token",
        component: ChangePasswordComponent,
      },
      {
        path: "remember/file/:token",
        component: DownloadPdfComponent,
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CoreModule, MatButtonModule, RouterModule.forChild(routes), MatInputModule, MatFormFieldModule, MatCheckboxModule, TranslateModule.forChild(), MatDialogModule, MatIconModule],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
  exports: [AuthComponent],
  declarations: [AuthComponent, LoginComponent, ForgotPasswordComponent, ChangePasswordComponent, DownloadPdfComponent, listTermsComponent, RecaptchaDirective, InputCodeComponent],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [AuthGuard],
    };
  }
}
